"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aria = void 0;
const data = new Set(['success']);
const aria = (props) => {
    const labels = Object.keys(props);
    const result = {};
    labels.forEach((label) => {
        if (props[label]) {
            result[`${data.has(label) ? 'data' : 'aria'}-${label}`] =
                'true';
        }
    });
    return result;
};
exports.aria = aria;
